var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanceled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#D00074"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.538 10.5 2.01-2.01a.734.734 0 1 0-1.038-1.038l-2.01 2.01-2.01-2.01A.734.734 0 1 0 7.452 8.49l2.01 2.01-2.01 2.01a.734.734 0 1 0 1.038 1.037l2.01-2.01 2.01 2.01a.732.732 0 0 0 1.038 0 .734.734 0 0 0 0-1.038l-2.01-2.01z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceled);
export default __webpack_public_path__ + "static/media/Canceled.0f8df5c202af186d70a93cf8682d079f.svg";
export { ForwardRef as ReactComponent };